/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Delete_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Delete this share?" |
*
* @param {Team_Share_Delete_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_delete_confirm_title = /** @type {((inputs?: Team_Share_Delete_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Delete_Confirm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Delete this share?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Delete this share?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Delete this share?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Delete this share?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Delete this share?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Delete this share?")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Delete this share?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Delete this share?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Delete this share?")
	return /** @type {LocalizedString} */ ("Delete this share?")
});